import { useEffect } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { useQueryParams } from '@/hooks/useQueryParams';
import { useScheduleContext } from '@/pages/Schedule/contexts';
import { getScheduleSlug } from '@/utils/schedule';

export const useSyncUrl = (isEntryModalOpen: boolean) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { queryParams } = useQueryParams();
  const { schedule } = useScheduleContext();

  useEffect(() => {
    return () => {
      if (
        isEntryModalOpen &&
        schedule &&
        matchPath('/schedule/:slug/item/*', pathname)
      ) {
        const slug = getScheduleSlug(schedule);
        const query = queryParams.toString();
        navigate(`/schedule/${slug}/?${query}`, { replace: true });
      }
    };
  }, [isEntryModalOpen, navigate, pathname, schedule, queryParams]);
};
